<template>
  <b-badge :variant="variant">
    <i v-if="icon" :class="icon" />
    {{ result_export.status }}
  </b-badge>
</template>

<script>
export default {
  name: "ResultExportStatusBadge",
  components: {},
  props: ["result_export"],
  data() {
    return {};
  },
  computed: {
    variant() {
      switch (this.result_export.status) {
        // completed states
        case "Complete":
          return "success";

        // working states
        case "Created":
        case "Built":
        case "Building":
        case "Converting":
          return "primary";

        // error states
        case "Error":
          return "danger";

        // defualt
        default:
          return "warning";
      }
    },
    /**
     * Get icon associated with status
     */
    icon() {
      switch (this.result_export.status) {
        // completed states
        case "Complete":
          return "fa fa-check";

        // working states
        case "Created":
        case "Built":
        case "Building":
        case "Converting":
          return "fa fa-spinner fa-spin";

        // error states
        case "Error":
          return "fa fa-warning-sign";

        // defualt
        default:
          return null;
      }
    },
  },
  methods: {},
};
</script>
